import "./signalr/jquery.signalR.min.js";
import moment from "moment";
import LazyLoad from 'vanilla-lazyload';
import rwd from './modules/rwd.js';
import swalPrompt from './modules/swal-prompt.js';
import breakingPointRowHandler from './modules/breaking-point-row-handler.js';
import copyToClipboard from './modules/copy-to-clipboard.js';
import realtime from './modules/realtime.js';
import sidebar from './modules/sidebar.js';
import popups from './modules/popups.js';
import prettyInputAndChosen from './modules/pretty-input-and-chosen.js';
import DnsResolve from './modules/dns-resolve.js';
import various from './modules/various.js';
import orderStateChanger from './modules/order-state-changer.js';
import datePicker from './modules/date-picker.js';
import clickLoader from './modules/click-loader.js';
import genericSort from './modules/generic-sort.js';
import genericAutocomplete from './modules/generic-autocomplete.js';
import grossPriceCalculator from './modules/gross-price-calculator.js';
import columnsEditing from './modules/columns-editing.js';
import adminRowAction from './modules/admin-row-action.js';
import shipping from './modules/shipping.js';
import showcasePoints from './modules/showcase-points.js';
import linkify from './modules/linkify.js';
import tabs from './modules/tabs.js';
import codeEditor from './modules/code-editor.js';
import massAction from './modules/mass-action.js';
import imageUploader from './modules/image-uploader.js';
import dashboardCharts from './modules/dashboard-charts.js';
import actionTime from './modules/actiontime.js';
import tippyRunner from './modules/tippies.js';
import passwordStrength from './modules/password-strength.js';
(function ($) {
    var app = {
        init: function () {
            rwd();
            swalPrompt();
            breakingPointRowHandler();
            copyToClipboard();
            realtime();
            sidebar();
            popups();
            prettyInputAndChosen();
            DnsResolve();
            various();
            orderStateChanger();
            datePicker();
            clickLoader();
            genericSort();
            genericAutocomplete();
            grossPriceCalculator();
            columnsEditing();
            adminRowAction();
            shipping();
            showcasePoints();
            linkify();
            tabs();
            codeEditor();
            massAction();
            imageUploader();
            dashboardCharts();
            actionTime();
            tippyRunner();
            passwordStrength();
        }
    };

    $(function () {
        app.init();
        window.App = app;
    });

})(jQuery);

window.chartColors = {
    red: 'rgb(209, 76, 57)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};

window.optionPriceMassSet = function (sourceInput, targetClass) {
    var val = $("#" + sourceInput).val();

    $(targetClass).each(function () {
        $(this).val(val);
    });

    return false;
}
window.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazyload',
    unobserve_entered: true
});

window.EndRequestHandler = function (sender, args) {
    if ($("[data-state='just-edited']").length) {
        $("[data-state='just-edited']").addClass("animated pulse");
    }

    tippyRunner();
    popups();
    prettyInputAndChosen();
    adminRowAction();
}